var _path, _path2, _rect, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPdf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0481 15H3.96156C3.43172 15 3 14.5812 3 14.0673V1.9327C3 1.41876 3.43172 1 3.96156 1H11.5559C11.8699 1 12.1642 1.12373 12.3801 1.33311L14.6564 3.56016C14.8723 3.76954 14.9998 4.05506 14.9998 4.35962V14.0768C15.0096 14.5812 14.5779 15 14.0481 15Z",
    stroke: "#868FA0",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 5H11.9189C11.4108 5 11 4.58242 11 4.06593V1",
    stroke: "#868FA0",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 8,
    width: 11,
    height: 5,
    rx: 1,
    fill: "#868FA0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 11.9158V9H3.15038C3.37153 9 3.55994 9.04224 3.7156 9.12671C3.87126 9.21024 3.98991 9.32651 4.07153 9.47553C4.15411 9.6236 4.1954 9.79444 4.1954 9.98807C4.1954 10.1817 4.15364 10.3525 4.07011 10.5006C3.98658 10.6487 3.86557 10.764 3.70706 10.8466C3.5495 10.9292 3.35872 10.9704 3.13472 10.9704H2.40149V10.4764H3.03506C3.1537 10.4764 3.25146 10.456 3.32834 10.4152C3.40618 10.3734 3.46407 10.316 3.50204 10.2429C3.54096 10.1689 3.56041 10.0839 3.56041 9.98807C3.56041 9.89126 3.54096 9.80678 3.50204 9.73465C3.46407 9.66156 3.40618 9.60509 3.32834 9.56522C3.25051 9.52441 3.1518 9.504 3.03221 9.504H2.61648V11.9158H2Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.74973 11.9158H4.7161V9H5.75827C6.05156 9 6.30404 9.05837 6.5157 9.17512C6.72736 9.29092 6.89014 9.45749 7.00404 9.67485C7.11889 9.89221 7.17631 10.1523 7.17631 10.4551C7.17631 10.7588 7.11889 11.0198 7.00404 11.2381C6.89014 11.4564 6.72641 11.6239 6.51285 11.7407C6.30024 11.8574 6.04587 11.9158 5.74973 11.9158ZM5.33258 11.3876H5.72411C5.90634 11.3876 6.05963 11.3553 6.18397 11.2908C6.30926 11.2253 6.40323 11.1242 6.46587 10.9875C6.52946 10.8499 6.56126 10.6724 6.56126 10.4551C6.56126 10.2396 6.52946 10.0635 6.46587 9.92685C6.40323 9.79017 6.30973 9.68956 6.1854 9.62502C6.06106 9.56048 5.90777 9.52821 5.72553 9.52821H5.33258V11.3876Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75325 11.9158V9H9.68384V9.50827H8.36973V10.2031H9.5557V10.7113H8.36973V11.9158H7.75325Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.1b89d318.svg";
export { ForwardRef as ReactComponent };